import React from 'react';
import { QuoteIcon } from 'lucide-react';
import type { Voice } from '../data/testimonials';
type TestimonialsProps = {
  voices: Voice[];
  title?: string;
  background?: 'white' | 'panel';
};

/**
 * "Leader voices": frases reales de líderes en foros públicos (VOC de la
 * ficha), con fuente. No se presentan como reseñas del producto.
 */
export function Testimonials({
  voices,
  title = 'Sound familiar?',
  background = 'white'
}: TestimonialsProps) {
  if (voices.length === 0) return null;
  const bg = background === 'white' ? 'bg-white' : 'bg-paper-dark';
  return <section aria-label={title} className={`w-full text-pine ${bg}`} data-id="element-257" data-mp="2x0tgkgs46inb">
      <div className="mx-auto max-w-6xl px-5 py-14 sm:py-20" data-id="element-258" data-mp="2x11rw48l9fwe">
        <div className="text-center" data-id="element-259" data-mp="2s2rwptmv6fas">
          <p className="eyebrow text-ember-deep" data-id="element-260" data-mp="2s3t8k0bpf5tk">Leader to leader</p>
          <h2 className="trail-underline mt-3 font-display text-[30px] leading-tight text-pine sm:text-5xl" data-id="element-261" data-mp="v8589t0m550o">
            {title}
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-[15px] text-pine-soft" data-id="element-262" data-mp="q8iw7mwitutg">
            Real words from volunteer leaders in public forums. This is exactly
            the week Troop Night Ready was built for.
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-263" data-mp="78k4pejyugs7">
          {voices.map(item => <figure key={item.quote} className="trail-card rounded-2xl border border-paper-dark bg-paper p-6" data-id="element-264" data-mp="c7wn9n3t11oz">
              <QuoteIcon className="h-7 w-7 text-ember" aria-hidden="true" data-id="element-265" data-mp="zysfglc69ywr" />
              <blockquote className="field-note mt-2 text-[28px] leading-[1.1] text-pine" data-id="element-266" data-mp="14ur4mb5brky8">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-4 text-xs text-pine-soft" data-id="element-267" data-mp="v57kz39sfn2b">
                <span className="block text-[13px] font-bold text-pine" data-id="element-268" data-mp="v3d2rwpwi91x">
                  {item.author}
                </span>
                {item.source}
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-6 text-center text-[11px] text-pine-muted" data-id="element-269" data-mp="1xiisiwe1nkip">
          Quoted as written from public leader forums. Not reviews of this
          product.
        </p>
      </div>
    </section>;
}